import React, { createContext, useState, useEffect, useCallback } from "react";
import { Snackbar, Alert } from "@mui/material";

export const FeedbackContext = createContext();

const FeedbackProvider = FeedbackContext.Provider;

export function FeedbackWrapper({ children }) {
  const [feedbackQueue, setFeedbackQueue] = useState([]);
  const [currentSnackbar, setCurrentSnackbar] = useState(null);

  // Process the feedback queue
  useEffect(() => {
    if (feedbackQueue.length > 0 && !currentSnackbar) {
      setCurrentSnackbar(feedbackQueue[0]);
      setFeedbackQueue((prevQueue) => prevQueue.slice(1));
    }
  }, [feedbackQueue, currentSnackbar]);

  // Close the current snackbar
  const handleCloseSnackbar = useCallback(() => {
    setCurrentSnackbar(null);
  }, []);

  // Add a new snackbar to the queue
  const dispatchFeedback = useCallback((snackbar) => {
    setFeedbackQueue((prevQueue) => [...prevQueue, snackbar]);
  }, []);

  // Memoize the context value
  const contextValue = React.useMemo(
    () => ({ dispatchFeedback }),
    [dispatchFeedback]
  );

  return (
    <FeedbackProvider value={contextValue}>
      {children}
      <Snackbar
        open={Boolean(currentSnackbar)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={8000}
        onClose={handleCloseSnackbar}
      >
        {currentSnackbar && (
          <Alert
            variant="filled"
            sx={{ minWidth: "400px" }}
            severity={currentSnackbar.payload.status || "info"}
            onClose={handleCloseSnackbar}
          >
            {currentSnackbar.payload.message}
          </Alert>
        )}
      </Snackbar>
    </FeedbackProvider>
  );
}
